.mediaPreview {
  height: 10rem;
  width: 10rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex: none;

  @media (pointer: fine) {
    &:hover {
    }
  }

  img {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
  }
}

.mediaPreviewActive {
  position: relative;
  &::before {
    content: '';
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: thin solid var(--color-white);

    @media (--screen-sm-down) {
      border-width: thin;
    }
  }
}

.mediaPreviewXxs {
  width: var(--media-xxs) !important;
  height: var(--media-xxs) !important;
}

.mediaPreviewXs {
  width: var(--media-xs) !important;
  height: var(--media-xs) !important;
}

.mediaPreviewS {
  width: var(--media-s) !important;
  height: var(--media-s) !important;
}

.mediaPreviewM {
  width: var(--media-m) !important;
  height: var(--media-m) !important;
}

.mediaPreviewL {
  width: var(--media-l) !important;
  height: var(--media-l) !important;
}

.mediaPreviewVideoFlag {
  position: absolute;
  bottom: 0.3rem;
  right: 0.3rem;
  text-align: right;
  background: var(--color-black);
  border-radius: var(--border-radius-secondary);
  padding: var(--gap-small);
  line-height: 1;
  font-size: 1.2rem;
  color: var(--color-white);
  display: flex;

  @media (--screen-xs-down) {
    padding: calc(var(--gap-small) / 2);
    font-size: 1rem;
  }
}
